<template>
    <div v-if="header.title || header.icon" class="menu group relative background z-20">
        <a v-bind="header.link ? { href: header.link } : {}" :title="header.hint || ''" :class="[
            'flex items-center',
            'px-1 py-2 block rounded-lg cursor-pointer whitespace-nowrap font-semibold',
            'text-[var(--white)]',
            header.title && 'sm:px-3',
            header.outline ? 'btn-primary btn font-semibold' : 'btn-secondary sm:mx-2',
            header.left_margin && 'sm:ml-12'
        ]">
            <span>{{ header.title }}</span>
            <Icon v-if="header.icon" :name="header.icon" :class="{ 'text-2xl': !header.title }" />
            <Icon v-if="header.items?.length" name="material-symbols:keyboard-arrow-down" class="ml-1" />
        </a>
        <div v-if="header.items?.length"
            class="child-menu block lg:absolute lg:left-0 lg:top-full py-4 px-6 rounded-md lg:shadow-xl shadow-lg border lg:border-0 w-full"
            :class="!columns ? 'menu-dropdown1' : 'menu-dropdown'" :style="{
                marginTop: '-0.25rem',
                paddingTop: '1.25rem',
            }">
            <div class="grid gap-4" :class="columns ? `grid-cols-${columns}` : ''">
                <HoverMenuItem2 :item="item" v-for="item in header.items" :key="item.title" />
            </div>
        </div>
    </div>

</template>

<script lang="ts">
export type TMenuItem = {
    icon?: string;
    container_class?: string;
    title?: string;
    class?: string;
    link?: string;
    badge?: string;
    items?: TMenuItem[];
    items_class?: string;
};

export type TMenu = {
    title: string;
    hint?: string;
    outline?: boolean,
    left_margin?: boolean,
    icon?: string,
    link?: string,
    items?: TMenuItem[];
}

export default {
    props: {
        header: {
            type: Object as PropType<TMenu>,
            required: true,
        },
        columns: Number
    },
}
</script>


<style scoped>
/* Bridge the gap between menu item and dropdown */
.menu-dropdown::before {
    content: '';
    position: absolute;
    top: -0.5rem;
    left: 0;
    right: 0;
    height: 0.5rem;
    background: transparent;
}


/* Dynamic width based on columns */
.menu-dropdown {
    width: 100%;
}

@media (min-width: 1024px) {
    /* Grow to fit the widest column (labels + "New" badges are nowrap) */
    .menu-dropdown {
        width: max-content;
        max-width: 90vw;
        min-width: var(--dropdown-width, 640px);
    }

    .menu-dropdown1 {
        width: var(--dropdown-width, 300px);
        max-width: 90vw;
        min-width: var(--dropdown-width, 300px);
    }
}
</style>